import { render } from "./ListUsers.vue?vue&type=template&id=f15f2428&ts=true"
import script from "./ListUsers.vue?vue&type=script&lang=ts"
export * from "./ListUsers.vue?vue&type=script&lang=ts"

import "./Users.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__